module.exports = __webpack_public_path__ + "image/icon_join_culture.png";